"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Linkify_1 = require("./Linkify");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Linkify_1).default; } });
